module.exports = __webpack_public_path__ + "img/the-netherlands-skin-connective-and-musculoskeletal-diseases-male.43adbb0b.png";